import * as Yup from 'yup'

const tlWarehouseLocationCreateSchema = Yup.object().shape({
  location    : Yup.string().required('Required'),
  sublocation : Yup.string().required('Required')
})

export default tlWarehouseLocationCreateSchema